import React, { useCallback, useEffect, useRef, useState } from "react"
import { Link, useLocation } from "react-router-dom"
import PropTypes from "prop-types"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"

//i18n
import { withTranslation } from "react-i18next"
import { generateReport } from "../../api"
import ReportModal from "../Common/ReportModal"

const SidebarContent = props => {
  const ref = useRef()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const activateParentDropdown = useCallback(item => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }, [])

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active") // li
            parent3.childNodes[0].classList.remove("mm-active")

            const parent4 = parent3.parentElement // ul
            if (parent4) {
              parent4.classList.remove("mm-show") // ul
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show") // li
                parent5.childNodes[0].classList.remove("mm-active") // a tag
              }
            }
          }
        }
      }
    }
  }

  const path = useLocation()
  const activeMenu = useCallback(() => {
    const pathName = path.pathname
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [path.pathname, activateParentDropdown])

  useEffect(() => {
    ref.current.recalculate()
  }, [])

  useEffect(() => {
    new MetisMenu("#side-menu")
    activeMenu()
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    activeMenu()
  }, [activeMenu])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen)
  }

  const handleGenerateReport = (startDate, endDate, format, includeOfficeExpenses) => {
    const formatName = format === "excel" ? "Excel" : "PDF"
    generateReport(startDate, endDate, format, includeOfficeExpenses)
      .then((response) => {
        if (response) {
          window.alert(`${formatName} ${props.t("report generated successfully and sent to Telegram!")}`)
        } else {
          console.error(props.t("Report generation failed"))
          window.alert(props.t("Report generation failed"))
        }
      })
      .catch((error) => {
        console.error(props.t("Error generating report") + ":", error)
        window.alert(props.t("Error generating report") + ": " + error.message)
      })
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>
            {/*<li>*/}
            {/*  <Link to="/#" className="has-arrow">*/}
            {/*    <i className="bx bx-file"></i>*/}
            {/*    <span>Контент</span>*/}
            {/*  </Link>*/}
            {/*  <ul className="sub-menu">*/}
            {/*    <li>*/}
            {/*      <Link to="/dashboard">Блог</Link>*/}
            {/*    </li>*/}
            {/*  </ul>*/}
            {/*</li>*/}
            <li>
              <Link to="/dashboard" className="sub-menu">
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Dashboard")}</span>
              </Link>
            </li>
            <li>
              <Link to="/users" className="sub-menu">
                <i className="bx bx-user"></i>
                <span>{props.t("Users")}</span>
              </Link>
            </li>
            <li>
              <Link to="/orders" className="sub-menu">
                <i className="bx bx-file"></i>
                <span>{props.t("Orders")}</span>
              </Link>
            </li>
            <li>
              <Link to="/create-exchange-order" className="sub-menu">
                <i className="bx bx-plus-circle"></i>
                <span>{props.t("Create Exchange Order")}</span>
              </Link>
            </li>
            <li>
              <Link to="/office-expenses" className="sub-menu">
                <i className="bx bx-receipt"></i>
                <span>{props.t("Office Expenses")}</span>
              </Link>
            </li>
            <li>
              <Link to="/balance-advances" className="sub-menu">
                <i className="bx bx-wallet"></i>
                <span>{props.t("Balance Advances")}</span>
              </Link>
            </li>
            <li>
              <Link to="/settings" className="sub-menu">
                <i className="bx bx-cog"></i>
                <span>{props.t("Settings")}</span>
              </Link>
            </li>
            <li>
              <Link onClick={(e)=>{
                e.preventDefault()
                toggleModal()
              }} to="#" className="sub-menu">

                <i className="bx bx-toggle-left"></i>
                <span>{props.t("Generate Report")}</span>
              </Link>
            </li>
          </ul>
        </div>
      </SimpleBar>
      <ReportModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        onGenerate={handleGenerateReport}
      />
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
